import { MapWorkspacePermissionType } from './map-workspace-permission';

export interface PermissionDTO {
    defaultPermission: MapWorkspacePermissionType;
    permissions: {
        id: string;
        type: PermissionType;
        name: string;
        permission: MapWorkspacePermissionType;
    }[];
}

// Example: "FULL_ACCESS": ["users:xxxxxx-xxxxb-4xx0-8xxb-xx6a", "users:xxxxxxx-xxx-4f2xx1-bxx0a9-bxxx1xx42"]
export type AccessControlList = Partial<Record<MapWorkspacePermissionType, string[]>>;

export interface TCObjectPermissions {
    defaultAccess?: MapWorkspacePermissionType;
    acl: AccessControlList;
    inheritance?: boolean;
}

export interface FileFolderPermissionsResponse {
    // FilePermissions do not have inherited permissions in the response. FolderPermissions will.
    directPermissions: TCObjectPermissions;
    inheritedPermissions?: TCObjectPermissions;
}

export enum PermissionType {
    USER = 'ConnectUser',
    GROUP = 'ConnectGroup',
    USER_LEGACY = 'USER',
    GROUP_LEGACY = 'GROUP'
}

export const permissionPriority = {
    [MapWorkspacePermissionType.FULL_ACCESS]: 0,
    [MapWorkspacePermissionType.READ]: 1,
    [MapWorkspacePermissionType.NO_ACCESS]: 2,
    [MapWorkspacePermissionType.NO_FILE_ACCESS]: 3,
    [MapWorkspacePermissionType.FILE_VIEW_MODE]: 4
};

export class Permission {
    // DTO properties
    defaultPermission: MapWorkspacePermissionType = null;
    permissions: { id: string; type: PermissionType; name: string; permission: MapWorkspacePermissionType }[] = [];

    // Added properties
    effectivePermission: MapWorkspacePermissionType; // effective permission for current user
}
